import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import Pair from './pages/Pair'
import Spaces from './pages/Spaces'
import Space from './pages/Space'
import Session from './pages/Session'
import RequireAuth from './components/RequireAuth'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/pair" element={<Pair />} />
        <Route path="/spaces" element={<RequireAuth><Spaces /></RequireAuth>} />
        <Route path="/spaces/:id" element={<RequireAuth><Space /></RequireAuth>} />
        <Route path="/sessions/:id" element={<RequireAuth><Session /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/spaces" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
